import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
//UI
import HeaderForm from '../headers/catalogs/HeaderForm';
import BtnTable from '../buttons/BtnTable';
import BtnContent from '../buttons/BtnContent';

const UploadFileModal = ({ funtion, message, error, process, title, resetState, getItems }) => {
    const [openModal, setOpenModal] = useState(false)
    const { reset, register, handleSubmit, formState: { errors } } = useForm();
    const dispatch = useDispatch();

    const handleOpenModal = (action) => {
        setOpenModal(action)
        if (action === false) {
            reset();
            dispatch(getItems())
            dispatch(resetState())
        }
    }

    const onSubmit = (data) => {
        const formData = new FormData();
        formData.append('file', data.file[0]);
        dispatch(funtion(formData));
    };

    return (
        <>

            <BtnTable action="upload_file" funtion={() => handleOpenModal(true)} />
            <dialog id="my_modal_3" className={`bg-gray-600/40 backdrop-blur-sm fixed top-0 w-full h-screen justify-center z-30 ${openModal ? "flex" : "hidden"} `}>
                <div className="modal-box p-5 max-w-xl max-h-[290px] contenedor mt-[120px] bg-white rounded-md">
                    <button onClick={() => handleOpenModal(false)} className="z-20 border-none text-gray-700 btn btn-sm btn-circle bg-rose-200  hover:bg-rose-400 absolute right-2 top-2">✕</button>
                    {error ?
                        <div className='flex flex-col p-2 w-full text-gray-800 border-red-500 rounded-md border mt-6 bg-red-200'>
                            <p className='mb-0'>{error}</p>
                        </div>
                        : ' '
                    }
                    <form onSubmit={handleSubmit(onSubmit)} className='text-gray-700'>
                        <HeaderForm title={title} />
                        <div className='flex gap-2 p-2 my-10'>
                            <div className={`flex text-start flex-col w-full cols cols-1`}>
                                <label className="text-sm flex items-center m-1 font-semibold">
                                    <p>Matriz de excel</p>
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className={`file-input-sm file-input-info file-input-bordered input-bordered bg-slate-200 focus:outline-none focus:ring-1 rounded-md shadow-base-400 shadow-md`}
                                    type='file'
                                    {...register("file", { required: true })}
                                />
                                {errors.file && (<span className="text-red-500 text-xs">{"required information"}</span>)}
                            </div>
                        </div>
                        {
                            process ?
                                <div className='flex flex-col items-center justify-center'>
                                    <span className="loading loading-ring loading-lg"></span>
                                    <h1>Creating...</h1>
                                </div>
                                : !process && message ?
                                    <div className='flex flex-col p-2 w-full text-gray-800 border-green-500 rounded-md border mt-6 bg-green-200'>
                                        <p className='mb-0'>{message}</p>
                                    </div>
                                    :
                                    <div className="flex items-center justify-start gap-2 border-t-2 border-t-orange-500 pt-4 mt-4">
                                        <BtnContent type="submit">{"Cargar información"}</BtnContent>
                                        <BtnContent type="cancel_modal" funtion={() => handleOpenModal(false)}>{"Cancelar"}</BtnContent>
                                    </div>
                        }

                    </form>
                </div>
            </dialog>
        </>
    );
};

export default UploadFileModal;